<template>
    <sa-page-layout :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :linkback="linkback" :showModalLoading="showModalLoading">
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Nome:</label>
                        <b-form-input v-model="filtroGestioneOspitiArchivio.nome" type="search" id="nome" placeholder="Nome"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Cognome:</label>
                        <b-form-input v-model="filtroGestioneOspitiArchivio.cognome" type="search" id="cognome" placeholder="Cognome"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Identificativo:</label>
                        <b-form-input v-model="filtroGestioneOspitiArchivio.identificativo" type="search" id="identificativo" :placeholder="this.$i18n.t('adi.lblFiscalCode')"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Presidio:</label>
                        <b-form-select v-model="filtroGestioneOspitiArchivio.idPresidio" :options="presidiOptions" :value="null" value-field="value" text-field="text" @change="onChangePresidio"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Regime:</label>
                        <b-form-select v-model="filtroGestioneOspitiArchivio.regime" :options="regimeOptions" :value="null" value-field="codice" text-field="descrizione"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Setting:</label>
                        <b-form-select v-model="filtroGestioneOspitiArchivio.settingCodice" :options="settingsPresidiOptions" :value="null" value-field="codice" text-field="setting"></b-form-select>
                    </b-col>
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <rsa-gestione-ospiti-list-archivio-component ref="RsaGestioneOspitiListArchivioComponent" @afterLoadData="onAfterLoadData"></rsa-gestione-ospiti-list-archivio-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaGestioneOspitiListArchivioComponent from "../components/RsaGestioneOspitiListArchivioComponent.vue";
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    components: { SaPageLayout, RsaGestioneOspitiListArchivioComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            filtroGestioneOspitiArchivio: { nome: null, cognome: null, identificativo: null, idPresidio: null, regime: null, settingCodice: null },
            btnBackVisible: true,
            linkback: "/home",
            pathResource: "/ospiti/archivio",
            linkedit: "/rsagestioneospiti",
            pathResourceUtentiPresidi: "/utentipresidi",
            pathResourceRegimi: "/accettazioneregimi",
            pathResourceSettingsPresidi: "/rsasettingspresidi",
            showModalLoading: false,
            listKey: 0,
            presidiOptions: [],
            regimeOptions: [],
            settingsPresidiOptions: [{ codice: null, setting: "-Seleziona Setting-" }],
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroGestioneOspitiArchivio"]) {
            me.filtroGestioneOspitiArchivio = JSON.parse(sessionStorage["filtroGestioneOspitiArchivio"]);
        }
        if (me.filtroGestioneOspitiArchivio.idPresidio) {
            me.loadData();
        }
        me.loadUserData();
        me.loadRegimi();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            let sessionStorage = window.sessionStorage;
            //   if (sessionStorage["filtroGestioneOspitiArchivio"]) {
            sessionStorage["filtroGestioneOspitiArchivio"] = JSON.stringify(me.filtroGestioneOspitiArchivio);
            //  }
            me.$refs.RsaGestioneOspitiListArchivioComponent.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onReset() {
            let me = this;
            me.filtroGestioneOspitiArchivio = { nome: null, cognome: null, identificativo: null, idPresidio: null, regime: null, settingCodice: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroGestioneOspitiArchivio"] = JSON.stringify(me.filtroGestioneOspitiArchivio);
            me.loadUserData();
            // me.$refs.RsaGestioneOspitiListArchivioComponent.resetList();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroGestioneOspitiArchivio"] = JSON.stringify(me.filtroGestioneOspitiArchivio);
            me.loadData();
        },
        loadUserData() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + "/users/profile";
            axios
                .get(link)
                .then((response) => {
                    me.utente = response.data.data;
                    me.user = me.utente;
                    me.nominativoUtente = me.utente.lastname + " " + me.utente.firstname;
                    me.ruolo = me.utente.profilo;
                    me.key = me.key++;
                    me.loadUtentiPresidi(me.utente.id);
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        loadUtentiPresidi(id) {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceUtentiPresidi, { idUtente: id }, me.resulResponseUtentiPresidi, me.resulErrorUtentiPresidi);
        },
        resulResponseUtentiPresidi(response) {
            let me = this;
            me.presidiOptions = [];
            if (response.data.data.list.length === 1) {
                me.filtroGestioneOspitiArchivio.idPresidio = response.data.data.list[0].idPresidio;
                me.presidiOptions.push({ text: response.data.data.list[0].denominazionePresidio, value: response.data.data.list[0].idPresidio });
            } else {
                response.data.data.list.forEach((element) => {
                    me.presidiOptions.push({ text: element.denominazionePresidio, value: element.idPresidio });
                });
            }
            me.presidiOptions.unshift({ text: "- Seleziona Valore -", value: null });
            me.loadData();
        },
        resulErrorUtentiPresidi(error) {
            console.log(error);
        },
        loadRegimi() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceRegimi;
            axios
                .get(link)
                .then((response) => {
                    me.regimeOptions = response.data.data.list;
                    me.regimeOptions.unshift({ codice: null, descrizione: "-Seleziona Regime-" });
                })
                .catch((error) => {
                    console.log("Il servizio dei regimi ha datao errore: " + error.response.status);
                });
        },
        onChangePresidio(value) {
            let me = this;
            me.loadSettingsPresidi(value);
        },
        loadSettingsPresidi(id) {
            let me = this;
            let params = { idPresidio: id };
            UtilityMixin.methods.loadDataResources(me.pathResourceSettingsPresidi, params, me.resultResponseSettings, me.resultErrorSettings);
        },
        resultResponseSettings(response) {
            let me = this;
            me.filtroGestioneOspitiArchivio.settingCodice = null;
            me.settingsPresidiOptions = response.data.data.list;
            if (me.settingsPresidiOptions.length === 1) {
                me.filtroGestioneOspitiArchivio.settingCodice = me.settingsPresidiOptions[0].codice;
            } //else {
            me.settingsPresidiOptions.unshift({ codice: null, setting: "-Seleziona Setting-" });
            // }
        },
        resultErrorSettings(response) {
            UtilityMixin.methods.messaggeBoxError(this, response);
        },
    },
};
</script>

<style></style>
